import {
  BUSINESSES_RESTART_FAILURE,
  BUSINESSES_RESTART_REQUEST,
  BUSINESSES_RESTART_SUCCESS,
} from '../actions/business_restart'

export function businessRestart(
  state = {
    isFetching: false,
    identities: null,
    errorMessage: null,
  },
  action
) {
  switch (action.type) {
    case BUSINESSES_RESTART_REQUEST:
      return { ...state, isFetching: true, identities: null, errorMessage: null }
    case BUSINESSES_RESTART_SUCCESS:
      return { ...state, isFetching: false, identities: action.response, errorMessage: null }
    case BUSINESSES_RESTART_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.error }
    default:
      return state
  }
}
